module.exports = __webpack_public_path__ + "static/media/arctic-min.9a76f3e7.jpg";